export default "__VITE_ASSET__692f9b4d__"